import { useEffect } from 'react';
import { useLocation } from 'react-router';

import useUserStore from '../../../stores/userStore';
import { trackShareSheetActionEvent } from '../../../Utils/analytics/shareSheet';
import { SHARE_SHEET_EVENTS } from '../../../Utils/analytics/constants';

const ConnectionRedirectPath = () => {
  const { search } = useLocation();
  const { setSlackCode } = useUserStore();

  const params = new URLSearchParams(search).entries();
  const queryParameters = Object.fromEntries(params);

  useEffect(() => {
    trackShareSheetActionEvent({
      app: 'slack',
      tab: 'connections',
      action: SHARE_SHEET_EVENTS.SUCCESSFUL_CONNECTION,
    });
    setSlackCode(queryParameters.code);
    window.close();
  }, [queryParameters.code, setSlackCode]);

  return queryParameters.code ? (
    <h1>You have been successfully authorised, please close this window</h1>
  ) : (
    <h1>Something went wrong, please try again</h1>
  );
};

export default ConnectionRedirectPath;
